/**
 * OBSOLETE - use google tag manager service instead:
 * src\EbaySweden.TouchWeb\static\script\app\ui\google-tagmanager-service.js
 *
 */
import defineComponent from 'flight';

function GoogleTagManager() {
    let hitCallbackCalled = false;

    this.defaultAttrs({
        gaEventTrackingSelector:
            'a[data-ga-category], button[data-ga-category]',
        gaShowEventTrackingSelector: '[data-ga-show]'
    });

    function pushToDataLayer(payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }

    this._trackPageView = function() {
        pushToDataLayer({ event: 'trackPageview' });
    };

    this._trackEvent = function(evt, analyticsData) {
        pushToDataLayer({
            event: 'trackEvent',
            eventCategory: analyticsData.category || '',
            eventAction: analyticsData.action || '',
            eventLabel: analyticsData.label || '',
            eventValue: analyticsData.value || '0',
            eventNonInteractive: this._isNonInteractive(analyticsData),
            hitCallback: analyticsData.hitCallback
        });
    };

    this._isNonInteractive = function(analyticsData) {
        if (analyticsData.userTriggered === undefined) {
            return true;
        }
        return !analyticsData.userTriggered;
    };

    this._trackEventFromLink = function(evt) {
        let link = $(evt.target).closest(this.attr.gaEventTrackingSelector),
            hitCallback = null;

        if (link.length === 0) {
            return;
        }

        /* jshint maxcomplexity:7 */
        let theUserWantsToOpenTheLinkInANewTab =
            evt.which > 1 ||
            evt.metaKey ||
            evt.ctrlKey ||
            evt.keyCode > 1 ||
            evt.shiftKey;

        if (
            link.attr('data-nav') === undefined &&
            !evt.isDefaultPrevented() &&
            !theUserWantsToOpenTheLinkInANewTab &&
            !link.attr('target')
        ) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            hitCallback = this._changeLocation(link.attr('href'));
        }

        this._sendTrackEvent(link, hitCallback);
    };

    this._changeLocation = function(href) {
        hitCallbackCalled = false;

        let hitCallback = function() {
            if (hitCallbackCalled === false) {
                // Avoid double-calls since the iPad seems to continue to setTimeout when using the back button
                hitCallbackCalled = true;
                if (href) {
                    window.location.href = href;
                }
            }
        };

        setTimeout(hitCallback, 1000);
        return hitCallback;
    };

    this._trackEventFromPjax = function(e, payload) {
        if (!payload.target) {
            return;
        }

        this._sendTrackEvent($(payload.target));
    };

    this._sendTrackEvent = function(link, hitCallback) {
        if (!this._hasCategoryOrLabel(link)) {
            return;
        }

        let payload = this._getPayloadFromLink(link);

        if (hitCallback) {
            payload.hitCallback = hitCallback;
        }

        this.trigger('analytics:track-event', payload);
    };

    this._getPayloadFromLink = function(link) {
        let payload = {
            category: link.data('ga-category') || '',
            action: link.data('ga-action') || 'Navigation',
            label: link.data('ga-label') || '',
            value: link.data('ga-value') || null
        };

        return payload;
    };

    this._hasCategoryOrLabel = function(link) {
        if (!link.data('ga-category') && !link.data('ga-label')) {
            return false;
        }
        return true;
    };

    this._trackShowEvent = function() {
        this.select('gaShowEventTrackingSelector').each(
            function(i, el) {
                let $el = $(el);
                let data = {
                    category: $el.data('ga-category') || '',
                    action: $el.data('ga-show') || 'Show',
                    label: $el.data('ga-label') || ''
                };
                this.trigger('analytics:track-event', data);
            }.bind(this)
        );
    };

    this._trackSearchFilterToggle = function(evt, payload) {
        let label = payload.expand === true ? 'Open' : 'Close';

        if (evt.type === 'ui:toggle:search-filters-categories') {
            label = label + ' categories';
        } else {
            label = label + ' filters';
        }

        this.trigger('analytics:track-event', {
            category: 'Search',
            action: 'Toggle',
            label: label
        });
    };

    this._trackCategoryMenuToggle = function(evt, payload) {
        if (!payload.open) {
            return;
        }

        this.trigger('analytics:track-event', {
            category: 'Category',
            action: 'Open category menu',
            label: 'Open category menu'
        });
    };

    this._userLoggedIn = function(evt, payload) {
        if (payload && payload.version) {
            this.trigger('analytics:track-event', {
                category: 'Login',
                action: 'Navigation',
                label: 'Successful login - member: ' + payload.memberId
            });
        } else {
            this.trigger('analytics:track-event', {
                category: 'Login',
                action: 'Login',
                label: 'member-' + payload.memberId
            });
        }

        pushToDataLayer({
            memberId: payload.memberId,
            loginState: 'logged in'
        });
    };

    this._trackSearchResultLayoutChange = function(evt, payload) {
        let gaPayload = {
            category: 'Search',
            action: 'Layout',
            label: payload.label
        };
        this.trigger('analytics:track-event', gaPayload);
    };

    this._clearPageVariables = function() {
        //Clear page variable
        pushToDataLayer({
            page: null
        });
        // Prevent previously set page variables to get a value of 0
        // There is probably a more elegant solution to this. Feel free to change
        pushToDataLayer({
            page: {}
        });
    };

    this.after('initialize', function() {
        this.on(document, 'analytics:track-event', this._trackEvent);
        this.on(
            document,
            'ui:navigation:after-page-change',
            this._trackPageView
        );
        this.on(
            document,
            'ui:toggle:search-filters ui:toggle:search-filters-categories',
            this._trackSearchFilterToggle
        );
        this.on(
            document,
            'ui:site-header:on-toggle-nav-categories',
            this._trackCategoryMenuToggle
        );
        this.on(document, 'data:login:logged-in', this._userLoggedIn);
        this.on(
            document,
            'ui:search:layout',
            this._trackSearchResultLayoutChange
        );
        this.on('click', this._trackEventFromLink);
        this.on(document, 'ui:navigate', this._trackEventFromPjax);
        this.on(document, 'ui:before-page-change', this._clearPageVariables);
        this.on(document, 'utils:window-load', this._trackShowEvent);
    });
}

export default defineComponent.component(GoogleTagManager);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/google-tagmanager.js